export default __webpack_public_path__ + "static/media/logo_white.88a740b5.svg";